/**
 * Converts cell type of custom header rows to simple text.
 * 
 * @param {any} row
 * @param {any} col
 * @param {any} cell
 * @param {any} prop
 * @param {any} table
 * @param {any} cellProperties
 */
export default function (row, col, cell, prop, table, cellProperties) {
    const customHeaderRows = table.customHeaderRows;
    if (typeof (customHeaderRows) !== "number") {
        return;
    }
    const headerRows = customHeaderRows;
    if (row < headerRows) {
        cellProperties.type = "text";
    }
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/cellprocessors/customHeaderProcessor.js